"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguageCodeAbbreviation = void 0;
const getLanguageCodeAbbreviation = languageCode => languageCode.replace(/-[a-z]{2}/i, '');
exports.getLanguageCodeAbbreviation = getLanguageCodeAbbreviation;